import { Action } from "redux";
import * as CleanOldVersionsActions from "../actions/CleanOldVersionsActions";
import { CleanOldVersionsDialogState } from "../model/CleanOldVersionsDialogState";

export function cleanOldVersionsDialogState(state: CleanOldVersionsDialogState = new CleanOldVersionsDialogState(), action: Action): CleanOldVersionsDialogState {
    switch (action.type) {
        case CleanOldVersionsActions.CLOSE_CLEAN_VERSIONS_DIALOG: {
            return new CleanOldVersionsDialogState();
        }
        case CleanOldVersionsActions.OPEN_CLEAN_VERSIONS_DIALOG: {
            const openCleanVersionsDialogAction = action as CleanOldVersionsActions.OpenCleanVersionsDialogAction;
            return openCleanVersionsDialogAction.dialogState;
        }
        case CleanOldVersionsActions.UPDATE_PROCESSES_MARKED_FOR_DELETION: {
            const updateActions = action as CleanOldVersionsActions.UpdateProcessMarkedForDeletionAction;
            const newProcessMarkedForDeletion = {
                [updateActions.processName]: updateActions.newValue
            };

            const cloned: Record<string, number> = Object.assign({}, state.processesMarkedForDeletion, newProcessMarkedForDeletion);
            const newState = Object.assign({}, state)
            newState.processesMarkedForDeletion = cloned;
            
            return newState;
        }
        default:
            return state;
    }
}
